/** @jsx jsx */
// TODO: remove eslint statement when 'css' is implemented
import { jsx } from '@emotion/react';
// eslint-disable-next-line no-unused-vars
import React, { useContext } from 'react';
import { PropertyDropdown } from 'components/dropdowns/propertyDropdown';
import { WorkspaceContext } from "views/workspace/workspaceContext";
import { WorkspaceActionCreator } from "hooks/useWorkspaceState";
import { selectDilDefinitionByName } from "srs-middleware";

export const PropertyListSelector = ({cardIndex, itemIndex, types, label, flags, endpointQuery, allowedProperties, isNullable = false, ...rest}) => {
  const {state: {explorer: {selectedDefinitionName}}, dispatch} = useContext(WorkspaceContext);

  const handlePropertySelection = (cardIndex, itemIndex, property) => {
    const newEndpointQuery = JSON.parse(JSON.stringify(endpointQuery));
    newEndpointQuery.options.propertyList[itemIndex] = property;
    dispatch(WorkspaceActionCreator.options(cardIndex, newEndpointQuery));
  }

  return (
    <PropertyDropdown
      selectedDefinition={selectDilDefinitionByName(selectedDefinitionName)}
      onSelectionChanged={(e) => handlePropertySelection(cardIndex, itemIndex, e?.name)}
      activeItem={endpointQuery?.options?.propertyList?.[itemIndex]}
      types={types}
      flags={flags}
      label={label}
      allowedProperties={allowedProperties}
      isNullable={isNullable}
      {...rest}
    />
  );
};
